<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  import ViewerButton from './btn.svelte';

  export let isMinimized = false;
  export let size: 'sm' | 'md' | 'lg' = 'md';
</script>

<ViewerButton {size} on:click>
  <div class="flex flex-nowrap gap-1.5 {cn({ 'pr-1': !isMinimized })}">
    <Icon name="scale-full" />
    {#if !isMinimized}
      <span class="text-nowrap text-sm font-medium">Full size</span>
    {/if}
  </div>
</ViewerButton>
